module.exports = __webpack_public_path__ + "static/Portrait-Light-be764f6d6c6bd2796d8f9a86a112b8c8.woff";